import initialState from "./initialState";
import {INSERT_ALERT, REMOVE_ALERT, SET_ALERTS, UPDATE_ALERT} from "../actions/AlertsActions";

export default (state = initialState.alerts, action) => {

    switch (action.type) {
        case INSERT_ALERT:
            return [action.payload.data, ...state];
        case SET_ALERTS:
            return action.payload.data;
        case REMOVE_ALERT:
            return state.filter(item => item.id !== action.payload.data.id );
        case UPDATE_ALERT:
            const alertForUpdate = action.payload.data;
            return state.map(item => {
                return (item.id === alertForUpdate.id )
                    ? {...item, ...alertForUpdate}
                    : {...item}
            });
        default:
            return state
    }
}
